/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GPC } from './GPC';
import type { ValuationApproachGpcCompGroup } from './ValuationApproachGpcCompGroup';
export type ValuationApproachGPC = {
    readonly id?: number;
    gpc_comparison?: Array<GPC>;
    valuationapproachgpccompgroup_set?: Array<ValuationApproachGpcCompGroup>;
    valuation_approach: number;
    first_non_forward_selection?: ValuationApproachGPC.first_non_forward_selection;
    second_non_forward_selection?: ValuationApproachGPC.second_non_forward_selection;
    first_forward_selection?: ValuationApproachGPC.first_forward_selection;
    second_forward_selection?: ValuationApproachGPC.second_forward_selection;
    multiple_basis: ValuationApproachGPC.multiple_basis;
    first_period_ebitda_selection?: ValuationApproachGPC.first_period_ebitda_selection;
    second_period_ebitda_selection?: ValuationApproachGPC.second_period_ebitda_selection;
    one_year_volatility_percentile_selection?: ValuationApproachGPC.one_year_volatility_percentile_selection;
    two_year_volatility_percentile_selection?: ValuationApproachGPC.two_year_volatility_percentile_selection;
    five_year_volatility_percentile_selection?: ValuationApproachGPC.five_year_volatility_percentile_selection;
    deleted_gpc_comparisons?: Array<number>;
    deleted_comp_groups?: Array<number>;
    deleted_multiple_premium_discount_objects?: Array<number>;
    deleted_company_as_of_date_performance_metric?: Array<number>;
    last_refresh_date?: string;
    name: string;
    is_deleted?: boolean | null;
    readonly deleted_at?: string | null;
    is_evaluating_equity_value?: boolean;
    first_non_forward_selected_multiple?: string | null;
    second_non_forward_selected_multiple?: string | null;
    first_forward_selected_multiple?: string | null;
    second_forward_selected_multiple?: string | null;
    first_non_forward_weighting?: string | null;
    second_non_forward_weighting?: string | null;
    first_forward_weighting?: string | null;
    second_forward_weighting?: string | null;
    weighted_enterprise_value?: string | null;
    weighted_equity_value?: string | null;
    ltm_financial_statement_period_id?: number | null;
    ntm_financial_statement_period_id?: number | null;
    percentile_selection_a?: number;
    percentile_selection_b?: number;
    use_adjusted_LTM_ebitda?: boolean;
    use_adjusted_NTM_ebitda?: boolean;
    use_multiple_premium_discount?: boolean;
    use_forward_multiple_discount?: boolean;
    first_non_forward_multiple_premium_discount?: string | null;
    second_non_forward_multiple_premium_discount?: string | null;
    first_forward_multiple_premium_discount?: string | null;
    second_forward_multiple_premium_discount?: string | null;
    one_year_volatility?: string | null;
    two_year_volatility?: string | null;
    five_year_volatility?: string | null;
    first_period_selection?: number | null;
    second_period_selection?: number | null;
    first_period_forward_selection?: number | null;
    second_period_forward_selection?: number | null;
};
export namespace ValuationApproachGPC {
    export enum first_non_forward_selection {
        SELECTED = 'Selected',
        _25TH_PERCENTILE = '25th Percentile',
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
    }
    export enum second_non_forward_selection {
        SELECTED = 'Selected',
        _25TH_PERCENTILE = '25th Percentile',
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
    }
    export enum first_forward_selection {
        SELECTED = 'Selected',
        _25TH_PERCENTILE = '25th Percentile',
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
    }
    export enum second_forward_selection {
        SELECTED = 'Selected',
        _25TH_PERCENTILE = '25th Percentile',
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
    }
    export enum multiple_basis {
        ENTERPRISE_VALUE = 'Enterprise Value',
        EV_EXCL_OP_LEASES = 'EV Excl Op Leases',
    }
    export enum first_period_ebitda_selection {
        EBITDA = 'EBITDA',
        ADJUSTED_EBITDA = 'Adjusted EBITDA',
    }
    export enum second_period_ebitda_selection {
        EBITDA = 'EBITDA',
        ADJUSTED_EBITDA = 'Adjusted EBITDA',
    }
    export enum one_year_volatility_percentile_selection {
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        _25TH_PERCENTILE = '25th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
        SPECIFIED = 'Specified',
    }
    export enum two_year_volatility_percentile_selection {
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        _25TH_PERCENTILE = '25th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
        SPECIFIED = 'Specified',
    }
    export enum five_year_volatility_percentile_selection {
        MEDIAN = 'Median',
        MEAN = 'Mean',
        _75TH_PERCENTILE = '75th Percentile',
        _25TH_PERCENTILE = '25th Percentile',
        SELECTION_A = 'Selection A',
        SELECTION_B = 'Selection B',
        SPECIFIED = 'Specified',
    }
}

